import { useCallback, useEffect, useMemo, useState } from "react";
import * as cc from "pages/dashboard/stats/ChartControlStyled";
import { RiCloseLine, RiPlayListAddLine } from "react-icons/ri";
import TableButton from "components/atoms/buttons/TableButton";
import { Layout } from "react-grid-layout";
import { addLayouttoLast, CARD_INFOS, cardDataToLayout } from "utils/StatsUtil";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import {
  CardData,
  CardInfo,
} from "api/interfaces/dashboardInterface.interface";

interface Props {
  onAddLayout: (selectedChartList: Layout[]) => void;
  onToggleAddLayout: () => void;
  showAddRemove: boolean;
  cardData: CardData[];
  hiddenCharts: CardInfo[];
}

export default function AddChart(props: Props) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [selectedChartList, setSelectedChartList] = useState<Layout[]>([]);

  const selectableList = useMemo(
    () =>
      CARD_INFOS.filter(
        (item) =>
          item.graphType !== "card" &&
          item.isRole.some((role) => selectedAccount.userPermission[role])
      ),
    [selectedAccount.userPermission]
  );
  const onApply = () => {
    props.onToggleAddLayout();
    props.onAddLayout(selectedChartList);
  };
  const onChangeCheckedList = useCallback((item: CardInfo) => {
    setSelectedChartList((prev) => {
      return addLayouttoLast(prev, item, CARD_INFOS);
    });
  }, []);

  useEffect(() => {
    setSelectedChartList(
      cardDataToLayout(
        props.cardData.filter(
          (item) => !props.hiddenCharts.some((h) => h.i === item.i)
        )
      )
    );
  }, [props.cardData, props.hiddenCharts]);

  return (
    <cc.AddChart.Container>
      <cc.FlowButton
        onClick={props.onToggleAddLayout}
        data-testid="dashboard-stats-graph-flow-button-set-is-open"
      >
        {props.showAddRemove ? (
          <RiCloseLine size={20} />
        ) : (
          <RiPlayListAddLine size={20} />
        )}
      </cc.FlowButton>
      {props.showAddRemove && (
        <cc.AddChart.Overlay>
          <h1>Select Chart Type</h1>
          <cc.AddChart.List>
            {selectableList.map((item) => (
              <li key={item.i}>
                <input
                  id={`add-chart-${item.i}`}
                  type="checkbox"
                  data-testid="dashboard-stats-graph-input-set-checked-list"
                  checked={selectedChartList.some((d) => d.i === item.i)}
                  onChange={(e) => onChangeCheckedList(item)}
                />
                <label htmlFor={`add-chart-${item.i}`}>{item.title}</label>
              </li>
            ))}
          </cc.AddChart.List>
          <cc.AddChart.Buttons>
            <TableButton
              label="Cancel"
              className="cancel"
              onClick={props.onToggleAddLayout}
              data-testid="dashboard-stats-graph-table-button-cancel"
            />

            <TableButton
              label="Apply"
              buttonType="primary"
              onClick={onApply}
              data-testid="dashboard-stats-graph-table-button-apply"
            />
          </cc.AddChart.Buttons>
        </cc.AddChart.Overlay>
      )}
    </cc.AddChart.Container>
  );
}
